import axios from 'axios'

export class Http {
  constructor () {
    this.instance = axios
    this.instance.defaults.headers.common = {
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true'
    }

    this.instance.defaults.baseURL = process.env.VUE_APP_API_URL

    return this.init()
  }

  init () {
    return this.instance
  }
}
